
<template>
    <div>
        <q-card flat>
            <q-card-section class="text-h6 q-px-sm" >
                <div class="row q-px-sm" >
                    <div class="col-xs-12 col-md-12 q-mb-md">
                        <div class="text-h6">{{$t("FundInfo.title2")}}</div>
                    </div>
                    <div id="applicableAmt" class="col-xs-12 col-md-12" style="font-size: 12px;">
                        <div class="q-pa-sm" style="background-color: #effaf5; color: #257953; border: 1px solid #257953; border-radius: 0.5rem; line-height: normal;">
                            {{$t("FundInfo.applicableamount")}} : {{TotalInvestment|thousandSeparator}}
                            </div>
                    </div>
                </div>
            </q-card-section>
            <q-card-section class="text-h6 q-px-sm" style="padding-bottom: 0px !important;">
                <div v-bind:key="invest.index" v-for="invest in StoreStateT.Transaction.Investment">
                <ListOfTransaction  :InvestmentObj=invest /><!--::TotalInvestment="TotalTransaction"-->
            </div>
            </q-card-section>
            <q-card-section align="right" class="row q-pt-none">
                <div class="col-md-9 col-xs-12 text-caption text-right q-pr-sm">{{$t("FundInfo.totalamount")}}</div>
                <div class="col-md-3 col-xs-12 text-bold text-right q-pl-md q-pr-sm">MYR {{TotalTransaction|thousandSeparator}}</div>
            </q-card-section>
       <!--  <q-item>
                <q-item-section>
                  <div class="q-px-md">
                      <q-toggle
                            v-model="StoreStateT.showAgent"
                            checked-icon="check"
                            color="primary"
                            :label='$t("FundInfo.servicingagent")'
                            left-label
                            unchecked-icon="clear"
                        />
                    </div>

                    
                <AgentSelection v-if="StoreStateT.showAgent"/>
              </q-item-section>
            </q-item>  -->
        </q-card>
    </div>
</template>

<style>

</style>

<script>
import { mapActions } from 'vuex';
import store from '../store'
import ListOfTransaction from '@/components/ListOfTransaction'/* 
import AgentSelection from '@/components/AgentSelection.vue' */
export default {
    name : 'TransactionDetails',
    components : {
        ListOfTransaction,
        /* AgentSelection */
    },
    data() {
        return {
            StoreStateLogin: store.state.Login,
            StoreStateT : store.state.Transactions
        }
    },  
    props: {
        InvestmentObj:Object,
    },
    computed: {

        TotalTransaction : function(){
             var total = ""
            var tempVall =""
            if(this.StoreStateT.Transaction.Investment.length!=0){
                for(var i=0;i<this.StoreStateT.Transaction.Investment.length;i++){
                    if((this.StoreStateT.Transaction.Investment[i].Amount!='')||(this.StoreStateT.Transaction.Investment[i].Amount!=undefined)){
                         
                        
                         if(!this.StoreStateT.Transaction.Investment[i].Amount.includes(',')){
                                tempVall = this.StoreStateT.Transaction.Investment[i].Amount
                                tempVall = parseFloat(tempVall).toFixed(2)
                                total = Number(total) + Number(tempVall)
                        }else{ 
                                tempVall = this.StoreStateT.Transaction.Investment[i].Amount.replace(",","");
                                //
                                tempVall = tempVall.replace(",","");
                                tempVall = tempVall.trim()
                                tempVall = parseFloat(tempVall).toFixed(2)
                                total = Number(total) + Number(tempVall)
                        }               
                    }
                }
            }
           

            this.$store.dispatch('Logging',{
                appid : '2',
                typeid :'4', 
                str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' TotalTransaction (buy),  total - > '+  total 
                //' this.StoreStateT.Transaction.Investment[i].Amount -->' + this.StoreStateT.Transaction.Investment[i].Amount
            });
            if(total === ""){
                return 0
            }else{

            return total;
            } 

        },
        TotalInvestment : function(){           
            return this.StoreStateT.Transaction.TotalInvestment;
        }
    },
    methods: {

    },
    filters: {
        thousandSeparator: function(value) {
            value = parseFloat(value).toFixed(2)
            if (value !== '' || value !== undefined || value !== 0  || value !== '0' || value !== '') {
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
                return value;
            }
        }
    }
}
</script>